import React, { useMemo } from "react";
import { Box, Typography, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import structure from "../structure";

const Reference = () => (
  <React.Fragment>
    <Typography variant="h5" gutterBottom>
      Reference
    </Typography>
    <ReferenceSection title="Components" pathName="components" />
    <ReferenceSection title="Hooks" pathName="hooks" />
    <ReferenceSection title="Action Creators" pathName="action-creators" />
    <ReferenceSection title="Selectors" pathName="selectors" />
    <ReferenceSection title="Configuration" pathName="configuration" />
  </React.Fragment>
);

const ReferenceSection = ({ title, pathName }) => {
  const items = useMemo(
    () =>
      structure
        .reduce((sections, s) => {
          return [
            ...sections,
            ...s.items
              .filter((g) => g.path.includes(pathName))
              .reduce((groups, g) => {
                return [
                  ...groups,
                  ...g.group.map((i) => ({
                    name: i.name,
                    path: `/${s.path}/${g.path}/${i.path}`,
                  })),
                ];
              }, []),
          ];
        }, [])
        .sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)),
    [pathName]
  );

  return (
    <Box my={3}>
      <Typography variant="h6" gutterBottom>
        {title} ({items.length})
      </Typography>
      {items.map((c) => (
        <Link
          key={c.name}
          component={RouterLink}
          to={c.path}
          display="block"
          width="fit-content"
        >
          {c.name}
        </Link>
      ))}
    </Box>
  );
};

export default Reference;
